import { render } from "./PaiementPaypal.vue?vue&type=template&id=ebeba7ce&scoped=true&ts=true"
import script from "./PaiementPaypal.vue?vue&type=script&lang=ts"
export * from "./PaiementPaypal.vue?vue&type=script&lang=ts"

import "./PaiementPaypal.vue?vue&type=style&index=0&id=ebeba7ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebeba7ce"]])

export default __exports__